export enum CloudUserImportFrom {
  TrustedDomain = 'TrustedDomain',
  TrustedDomainInt = 7,
  Excel = 'Excel',
  ActiveDomain = 'ActiveDomain',
  ActiveDomainInt = 4,
  Catalog = 'Catalog',
  Scim = 'Scim'
}
